import React from "react";
import { useParams } from "react-router";
import { useGet } from "../../api";
import { IMerchantSimple } from "../../interfaces";

export const MerchantConfiguration: React.FC = () => {
  const { _id } = useParams<{ _id: string }>();
  const { data: merchant } = useGet<IMerchantSimple>(`/merchants/${_id}`);

  return (
    <div>
      <legend>{merchant?.name}</legend>
    </div>
  );
};
